<template>
    <v-app-bar app class="listra" dark clipped-left>
        <!-- <v-row justify="center" align="center" align-content="center"> -->
        <v-col cols="4" class="text-center py-0">
            <v-img
            alt="Revelacha Name"
            class="shrink"
            contain
            min-width="100"
            :src="logo"
            width="290"
            />
        </v-col>
        <v-col cols="8" class="text-right">
            <v-btn tile outlined @click="goToLogin" v-if="loggedIn != 'true'">   
                <v-icon left>mdi-login</v-icon>                
                Acesso dos Papais                
            </v-btn>     
            <v-btn tile outlined @click="goToLogout" v-if="loggedIn == 'true'">   
                <v-icon left>mdi-logout</v-icon>                
                Encerrar Acesso                
            </v-btn>                 
        </v-col> 
        <!-- </v-row>     -->
    </v-app-bar>
</template>

<script>

    export default {
        props: {
            source: String,
        },
        data: () => ({
            drawer: null,
            messages: 1,
            logo: 'https://firebasestorage.googleapis.com/v0/b/revelacha.appspot.com/o/revelacha%20(8).png?alt=media&token=3d399792-dd7b-478c-9d79-cafbc2b0ccf7',
            loggedIn: false,
        }),
        created() {
            this.$vuetify.theme.ligth = true
            this.loggedIn = sessionStorage.getItem('loggedIn')
        },
        methods:{
            goToLogin(){
                this.$router.replace('/login')
            },
            goToLogout(){
                sessionStorage.clear()
                this.loggedIn = false
                this.$router.replace('/')
                this.$router.go()
            }
        }
    }
</script>

<style scoped>
.listra {
    /* background: repeating-linear-gradient(
        #296B74,
        #296B74 20px,
        #1C4C5A 20px,
        #1C4C5A 45px
    ); */
  background: linear-gradient(to right, #51c7fd, #f59cd3);
  background-size: cover;    
}
</style>